"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _emotionTheming = require("emotion-theming");

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _Header = require("./Header.style");

var SingleHeader = function SingleHeader(_ref) {
  var selectedLabel = _ref.selectedLabel,
      label = _ref.label,
      expanded = _ref.expanded,
      search = _ref.search,
      searchValue = _ref.searchValue,
      disabled = _ref.disabled,
      handleHeaderClick = _ref.handleHeaderClick,
      handleInputChange = _ref.handleInputChange,
      showSearchIcon = _ref.showSearchIcon,
      theme = _ref.theme,
      inputClassName = _ref.inputClassName,
      minWidth = _ref.minWidth,
      autoFocus = _ref.autoFocus;
  return _react.default.createElement(_Header.StyledSingleHeader, {
    disabled: disabled,
    isSelected: selectedLabel,
    onClick: disabled ? _noop.default : handleHeaderClick,
    tabIndex: 0,
    minWidth: minWidth,
    expanded: expanded,
    role: "button"
  }, search && showSearchIcon && _react.default.createElement(_Icon.default, {
    type: "search"
  }), search ? _react.default.createElement("input", {
    className: (0, _classnames.default)('SelectHeader__input', (0, _Header.singleInput)(theme), inputClassName),
    value: searchValue,
    placeholder: selectedLabel || label,
    onChange: handleInputChange,
    autoFocus: autoFocus,
    disabled: disabled
  }) : selectedLabel || label, !search && _react.default.createElement(_Icon.default, {
    type: "angle-down",
    rotate: expanded ? 180 : 0,
    style: {
      width: '14px',
      height: '14px',
      marginRight: '8px'
    }
  }));
};

SingleHeader.defaultProps = {
  selectedLabel: null
};
SingleHeader.propTypes = {
  label: _propTypes.default.string.isRequired,
  selectedLabel: _propTypes.default.string,
  expanded: _propTypes.default.bool.isRequired,
  search: _propTypes.default.bool.isRequired,
  searchValue: _propTypes.default.string.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  handleHeaderClick: _propTypes.default.func.isRequired,
  handleInputChange: _propTypes.default.func.isRequired,
  showSearchIcon: _propTypes.default.bool.isRequired,
  autoFocus: _propTypes.default.bool.isRequired
};

var _default = (0, _emotionTheming.withTheme)(SingleHeader);

exports.default = _default;